<template>
  <div class="content-box">
    <div class="element-wrapper">
      <div class="element-box">
        <h5 class="form-header">CXP Cargos</h5>
        <div class="controls-above-table">
          <div class="col-12">
            <div class="row">
              <div class="col-sm-2">
                <router-link
                  class="btn btn-md btn-success"
                  :to="{ name: 'cxp-cargo-nuevo', params: {} }"
                >
                  <i class="fa fa-plus"></i>
                  Nuevo Cargo
                </router-link>
              </div>
              <div class="col-2">
                <input
                  class="form-control form-control-sm rounded bright"
                  placeholder="Search"
                  v-model="searchtext"
                  type="text"
                  v-on:keyup.enter="filterData()"
                />
              </div>
              <div class="col-2">
                <select
                  class="form-control form-control-sm rounded bright"
                  v-model="filterActive"
                  @click="filterData"
                >
                  <option value="">Todos</option>
                  <option value="A">Abierto</option>
                  <option value="B">Cerrado</option>
                  <option value="9">Anulado</option>
                  <option value="E">Impreso</option>
                </select>
              </div>
              <div class="col-2">
                <div class="input-group-append">
                  <select
                    class="form-control form-control-sm rounded bright"
                    v-model="filterCargo"
                    @change="filterData()"
                  >
                    <option :value="null">Tipo</option>
                    <option v-for="(c, key) in tiposcargos" :value="c.id" :key="key">
                      {{ c.id }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="col-3">
                <ProveedoresSelectComponent
                  @onChange="filterData()"
                  :current="current"
                  titulo="hide"
                />
              </div>
              <div class="col-1">
                <div class="input-group-append">
                  <button class="btn btn-link btn-sm" type="button" @click="filterData">
                    <i class="fa fa-search"></i>
                  </button>
                  <button
                    class="btn btn-link btn-sm"
                    type="button"
                    v-on:click="clearFilterData"
                  >
                    <i class="fa fa-times"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-------------------- END - Controles arriba de tabla-------------------->
        <div class="table-responsive">
          <!-------------------- Tabla de REsultados -------------------->
          <table class="table table-hover">
            <thead>
              <tr>
                <th class="text-center">Número</th>
                <th class="text-center">Forma de Pago</th>
                <th class="text-center">Tipo</th>
                <th class="text-center">Proveedor</th>
                <th class="text-center">Fecha Docto</th>
                <th class="text-center">Saldo</th>
                <th class="text-center">Valor Total</th>
                <th class="text-center">Estado</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="current in data.results"
                v-bind:key="current.id"
                @click="rowClick(current)"
              >
                <td class="text-center">{{ current.numero }}</td>
                <td class="text-center">{{ current.forma_pago_str }}</td>
                <td
                  class="text-center"
                  v-if="current.tipo_cargo_obj && current.tipo_cargo_obj.nombre"
                >
                  {{ current.tipo_cargo_obj.nombre }}
                </td>
                <td
                  class="text-center"
                  v-if="current.proveedor_obj && current.proveedor_obj.nombre"
                >
                  {{ current.proveedor }} - {{ current.proveedor_obj.nombre }}
                </td>
                <td class="text-center">{{ current.fecha_documento }}</td>
                <td class="text-center">Q {{ current.total_pendiente }}</td>
                <td class="text-center">Q {{ current.valor_total }}</td>
                <td class="text-center" style="font-size: 12px">
                  {{ current.estado_str }}
                </td>
              </tr>
            </tbody>
          </table>
          <!-------------------- END - Basic Table -------------------->
        </div>
        <PaginationComponent
          :currentPage="currentPage"
          :data="data"
          @pagechanged="onPageChange"
        />
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import PaginationComponent from "@/components/utils/PaginationComponent";
import CargosService from "@/services/cxp/CargosService";
import OrdenCompraCargoTableComponent from "@/components/cxp/cargo/OrdenCompraCargoTableComponent";
import DynamicService from "@/services/commons/DynamicService";
import EntradaCompraTableComponent from "@/components/cxp/cargo/EntradaCompraTableComponent";
import ProveedoresSelectComponent from "@/components/commons/ProveedoresSelectComponent";

export default {
  components: {
    PaginationComponent,
    OrdenCompraCargoTableComponent,
    EntradaCompraTableComponent,
    ProveedoresSelectComponent,
  },
  data() {
    return {
      mostrarRefresh: false,
      currentPage: 1,
      searchtext: "",
      filterCargo: null,
      filterActive: "",
      data: [],
      tiposcargos: [],
      current: {
        proveedor: "",
      },
    };
  },
  computed: {},
  mounted() {
    this.refreshCargo();
    this.clearFilterData();
  },
  methods: {
    showModalAddCargonNew(detalle) {
      let self = this;
      $("#modalAddcargonNew").modal();
    },

    refreshCargo() {
      let self = this;
      DynamicService.fetch("cxp", "tipo-cargo", {
        quitar_paginacion: true,
      }).then((response) => {
        self.tiposcargos = response.data;
      });
    },
    onPageChange(page) {
      this.currentPage = page;
      this.refreshData({
        proveedor: this.current.proveedor.codigo,
        page: this.currentPage,
        "filter[search]": this.searchtext,
        tipo_cargo: this.filterCargo,
        estado: this.filterActive,
      });
    },
    filterData() {
      this.refreshData({
        proveedor: this.current.proveedor.codigo,
        page: 1,
        "filter[search]": this.searchtext,
        tipo_cargo: this.filterCargo,
        estado: this.filterActive,
      });
    },
    clearFilterData() {
      this.current.proveedor = "";
      this.searchtext = "";
      this.filterCargo = null;
      this.filterActive = "";
      this.refreshData({
        page: 1,
        "filter[search]": this.searchtext,
        tipo_cargo: this.filterCargo,
        estado: this.filterActive,
      });
    },
    hide: function () {
      this.$data.destroy();
    },
    onRefreshData() {},
    refreshData(params) {
      let self = this;
      CargosService.fetch(params).then((res) => {
        self.data = res.data;
      });
    },
    rowClick(current) {
      let self = this;
      if (event.ctrlKey) {
        let routeUrl = this.$router.resolve({
          name: "cxp-cargo-editar",
          params: { id: current.id },
        });
        window.open(routeUrl.href, "_blank");
      } else {
        self.$router.push({
          name: "cxp-cargo-editar",
          params: { id: current.id },
        });
      }
    },
    showModalEdit() {},
  },
};
</script>
